const topics = [
  { label: '暑期档推荐', hot: true, count: '2.3k' },
  { label: '高分动作片', hot: true, count: '1.8k' },
  { label: '国产喜剧', hot: false, count: '1.5k' },
  { label: 'IMDB Top250', hot: true, count: '3.1k' },
  { label: '漫威宇宙', hot: false, count: '1.2k' },
  { label: '周星驰经典', hot: true, count: '2.6k' },
  { label: '科幻必看', hot: false, count: '1.9k' },
  { label: '悬疑烧脑', hot: true, count: '1.4k' },
  { label: '奥斯卡获奖', hot: false, count: '2.0k' },
  { label: '日韩精选', hot: false, count: '1.1k' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            大家都在关注的电影话题，看看有没有你感兴趣的
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 ${
                topic.hot
                  ? 'bg-accent-50 border-accent-200 hover:bg-accent-100'
                  : 'bg-background-100 border-background-200/70 hover:bg-background-200'
              }`}
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-line text-accent-500 text-xs"></i>
                </span>
              )}
              <span className={`text-sm font-medium whitespace-nowrap ${
                topic.hot ? 'text-foreground-900' : 'text-foreground-700'
              }`}>
                {topic.label}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-8">
          <div className="inline-flex items-center gap-4 px-5 py-2.5 rounded-full bg-background-100 border border-background-200/70">
            <span className="text-xs text-foreground-600 whitespace-nowrap">
              <i className="ri-bar-chart-line mr-1 text-accent-500"></i>
              本周热门趋势：<strong className="text-foreground-900">暑期档推荐</strong> 热度上升最快
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}